import { GET } from "Data/API/Request";
import { deserializeJsonApiData } from "Data/Utils/Json";
import { IDataPage, IIndexSignature, IItem, IWithApiData } from "Interfaces";

export const getItems = (token: string, params?: IIndexSignature<string | number>) => {
	return GET("items", token, { ...params, include: "updater,order" })
		.then((response: IWithApiData) => {
			return deserializeJsonApiData<Partial<IItem>[]>(response).then((items: Partial<IItem>[]) => {
				return { ...response, data: items } as IDataPage<IItem>;
			});
		});
};

export const getItem = (id: string, token: string) => {
	return GET(`items/${ id }`, token)
		.then((response: IWithApiData) => {
			return deserializeJsonApiData<Partial<IItem>>(response);
		});
};
